import {
  GET_PAYROLL_RUN_LIST,
  GET_PAYROLL_RUN_LIST_SUCCESS,
  GET_PAYROLL_RUN_LIST_FAILURE,
  GET_PAYROLL_RUN_DATA,
  GET_PAYROLL_RUN_DATA_SUCCESS,
  GET_PAYROLL_RUN_DATA_FAILURE,
  PAYROLL_CREATE_PREVIEW,
  PAYROLL_CREATE_PREVIEW_SUCCESS,
  PAYROLL_CREATE_PREVIEW_FAILURE,
  PAYROLL_CREATE_PREVIEW_PDF,
  PAYROLL_CREATE_PREVIEW_PDF_SUCCESS,
  PAYROLL_CREATE_PREVIEW_PDF_FAILURE,
  PAYROLL_CREATE,
  PAYROLL_CREATE_SUCCESS,
  PAYROLL_CREATE_FAILURE,
  PAYROLL_UPDATE,
  PAYROLL_UPDATE_SUCCESS,
  PAYROLL_UPDATE_FAILURE,
  PAYROLL_DELETE,
  PAYROLL_DELETE_SUCCESS,
  PAYROLL_DELETE_FAILURE,
  GET_PAYROLL_PAYSLIP_DATA,
  GET_PAYROLL_PAYSLIP_DATA_SUCCESS,
  GET_PAYROLL_PAYSLIP_DATA_FAILURE,
  GET_PAYROLL_PAYSLIP_PDF,
  GET_PAYROLL_PAYSLIP_PDF_SUCCESS,
  GET_PAYROLL_PAYSLIP_PDF_FAILURE,
  GET_PAYROLL_HMRC_LIST,
  GET_PAYROLL_HMRC_LIST_SUCCESS,
  GET_PAYROLL_HMRC_LIST_FAILURE,
  PAYROLL_HMRC_SUBMIT,
  PAYROLL_HMRC_SUBMIT_SUCCESS,
  PAYROLL_HMRC_SUBMIT_FAILURE,
  PAYROLL_HMRC_SETTINGS_SAVE,
  PAYROLL_HMRC_SETTINGS_SAVE_SUCCESS,
  PAYROLL_HMRC_SETTINGS_SAVE_FAILURE,
  GET_PAYROLL_HMRC_SETTINGS_DATA,
  GET_PAYROLL_HMRC_SETTINGS_DATA_SUCCESS,
  GET_PAYROLL_HMRC_SETTINGS_DATA_FAILURE,
  PAYROLL_RESET_RESPONSE,
} from "./actionType";

const initialState = {
  // List
  payrollRunList: [],
  payrollRunListLoading: false,
  // Detail
  payrollRunData: [],
  payrollRunDataLoading: false,
  // Preview (no writes)
  payrollPreviewResponse: [],
  payrollPreviewLoading: false,
  // Preview PDF
  payrollPreviewPdfResponse: [],
  payrollPreviewPdfLoading: false,
  // Commit
  payrollCreateResponse: [],
  payrollCreateLoading: false,
  // Update
  payrollUpdateResponse: [],
  payrollUpdateLoading: false,
  // Delete
  payrollDeleteResponse: [],
  payrollDeleteLoading: false,
  // Payslip data
  payrollPayslipData: [],
  payrollPayslipDataLoading: false,
  // Payslip PDF
  payrollPayslipPdfResponse: [],
  payrollPayslipPdfLoading: false,
  // HMRC submission history
  payrollHmrcList: [],
  payrollHmrcListLoading: false,
  // HMRC submit/retry
  payrollHmrcSubmitResponse: [],
  payrollHmrcSubmitLoading: false,
  // HMRC settings — save
  payrollHmrcSettingsSaveResponse: [],
  payrollHmrcSettingsSaveLoading: false,
  // HMRC settings — read
  payrollHmrcSettingsData: [],
  payrollHmrcSettingsDataLoading: false,

  error: null,
};

// transient response keys that PAYROLL_RESET_RESPONSE can clear
const transientKeys = [
  "payrollPreviewResponse",
  "payrollPreviewPdfResponse",
  "payrollCreateResponse",
  "payrollUpdateResponse",
  "payrollDeleteResponse",
  "payrollPayslipPdfResponse",
  "payrollHmrcSubmitResponse",
  "payrollHmrcSettingsSaveResponse",
];

const Payroll = (state = initialState, action) => {
  switch (action.type) {
    // List
    case GET_PAYROLL_RUN_LIST:
      return { ...state, payrollRunListLoading: true };
    case GET_PAYROLL_RUN_LIST_SUCCESS:
      return {
        ...state,
        payrollRunListLoading: false,
        payrollRunList: action.payload,
      };
    case GET_PAYROLL_RUN_LIST_FAILURE:
      return {
        ...state,
        payrollRunListLoading: false,
        error: action.payload,
      };

    // Detail
    case GET_PAYROLL_RUN_DATA:
      return { ...state, payrollRunDataLoading: true };
    case GET_PAYROLL_RUN_DATA_SUCCESS:
      return {
        ...state,
        payrollRunDataLoading: false,
        payrollRunData: action.payload,
      };
    case GET_PAYROLL_RUN_DATA_FAILURE:
      return {
        ...state,
        payrollRunDataLoading: false,
        error: action.payload,
      };

    // Preview (no writes)
    case PAYROLL_CREATE_PREVIEW:
      return { ...state, payrollPreviewLoading: true };
    case PAYROLL_CREATE_PREVIEW_SUCCESS:
      return {
        ...state,
        payrollPreviewLoading: false,
        payrollPreviewResponse: action.payload,
      };
    case PAYROLL_CREATE_PREVIEW_FAILURE:
      return {
        ...state,
        payrollPreviewLoading: false,
        error: action.payload,
      };

    // Preview PDF
    case PAYROLL_CREATE_PREVIEW_PDF:
      return { ...state, payrollPreviewPdfLoading: true };
    case PAYROLL_CREATE_PREVIEW_PDF_SUCCESS:
      return {
        ...state,
        payrollPreviewPdfLoading: false,
        payrollPreviewPdfResponse: action.payload,
      };
    case PAYROLL_CREATE_PREVIEW_PDF_FAILURE:
      return {
        ...state,
        payrollPreviewPdfLoading: false,
        error: action.payload,
      };

    // Commit
    case PAYROLL_CREATE:
      return { ...state, payrollCreateLoading: true };
    case PAYROLL_CREATE_SUCCESS:
      return {
        ...state,
        payrollCreateLoading: false,
        payrollCreateResponse: action.payload,
      };
    case PAYROLL_CREATE_FAILURE:
      return {
        ...state,
        payrollCreateLoading: false,
        error: action.payload,
      };

    // Update
    case PAYROLL_UPDATE:
      return { ...state, payrollUpdateLoading: true };
    case PAYROLL_UPDATE_SUCCESS:
      return {
        ...state,
        payrollUpdateLoading: false,
        payrollUpdateResponse: action.payload,
      };
    case PAYROLL_UPDATE_FAILURE:
      return {
        ...state,
        payrollUpdateLoading: false,
        error: action.payload,
      };

    // Delete
    case PAYROLL_DELETE:
      return { ...state, payrollDeleteLoading: true };
    case PAYROLL_DELETE_SUCCESS:
      return {
        ...state,
        payrollDeleteLoading: false,
        payrollDeleteResponse: action.payload,
      };
    case PAYROLL_DELETE_FAILURE:
      return {
        ...state,
        payrollDeleteLoading: false,
        error: action.payload,
      };

    // Payslip data
    case GET_PAYROLL_PAYSLIP_DATA:
      return { ...state, payrollPayslipDataLoading: true };
    case GET_PAYROLL_PAYSLIP_DATA_SUCCESS:
      return {
        ...state,
        payrollPayslipDataLoading: false,
        payrollPayslipData: action.payload,
      };
    case GET_PAYROLL_PAYSLIP_DATA_FAILURE:
      return {
        ...state,
        payrollPayslipDataLoading: false,
        error: action.payload,
      };

    // Payslip PDF
    case GET_PAYROLL_PAYSLIP_PDF:
      return { ...state, payrollPayslipPdfLoading: true };
    case GET_PAYROLL_PAYSLIP_PDF_SUCCESS:
      return {
        ...state,
        payrollPayslipPdfLoading: false,
        payrollPayslipPdfResponse: action.payload,
      };
    case GET_PAYROLL_PAYSLIP_PDF_FAILURE:
      return {
        ...state,
        payrollPayslipPdfLoading: false,
        error: action.payload,
      };

    // HMRC submission history
    case GET_PAYROLL_HMRC_LIST:
      return { ...state, payrollHmrcListLoading: true };
    case GET_PAYROLL_HMRC_LIST_SUCCESS:
      return {
        ...state,
        payrollHmrcListLoading: false,
        payrollHmrcList: action.payload,
      };
    case GET_PAYROLL_HMRC_LIST_FAILURE:
      return {
        ...state,
        payrollHmrcListLoading: false,
        error: action.payload,
      };

    // HMRC submit/retry
    case PAYROLL_HMRC_SUBMIT:
      return { ...state, payrollHmrcSubmitLoading: true };
    case PAYROLL_HMRC_SUBMIT_SUCCESS:
      return {
        ...state,
        payrollHmrcSubmitLoading: false,
        payrollHmrcSubmitResponse: action.payload,
      };
    case PAYROLL_HMRC_SUBMIT_FAILURE:
      return {
        ...state,
        payrollHmrcSubmitLoading: false,
        error: action.payload,
      };

    // HMRC settings — save
    case PAYROLL_HMRC_SETTINGS_SAVE:
      return { ...state, payrollHmrcSettingsSaveLoading: true };
    case PAYROLL_HMRC_SETTINGS_SAVE_SUCCESS:
      return {
        ...state,
        payrollHmrcSettingsSaveLoading: false,
        payrollHmrcSettingsSaveResponse: action.payload,
      };
    case PAYROLL_HMRC_SETTINGS_SAVE_FAILURE:
      return {
        ...state,
        payrollHmrcSettingsSaveLoading: false,
        error: action.payload,
      };

    // HMRC settings — read
    case GET_PAYROLL_HMRC_SETTINGS_DATA:
      return { ...state, payrollHmrcSettingsDataLoading: true };
    case GET_PAYROLL_HMRC_SETTINGS_DATA_SUCCESS:
      return {
        ...state,
        payrollHmrcSettingsDataLoading: false,
        payrollHmrcSettingsData: action.payload,
      };
    case GET_PAYROLL_HMRC_SETTINGS_DATA_FAILURE:
      return {
        ...state,
        payrollHmrcSettingsDataLoading: false,
        error: action.payload,
      };

    // Reset transient responses
    case PAYROLL_RESET_RESPONSE: {
      const keys =
        Array.isArray(action.payload) && action.payload.length
          ? action.payload
          : transientKeys;
      const cleared = {};
      keys.forEach((k) => {
        cleared[k] = [];
      });
      return { ...state, ...cleared };
    }

    default:
      return state;
  }
};

export default Payroll;
